export class AuthV2AssociateSoftwareTokenResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "secretCode",
            "baseName": "secretCode",
            "type": "string",
            "format": ""
        },
        {
            "name": "otpauthUri",
            "baseName": "otpauthUri",
            "type": "string",
            "format": ""
        },
        {
            "name": "qrCodeImage",
            "baseName": "qrCodeImage",
            "type": "string",
            "format": ""
        },
        {
            "name": "session",
            "baseName": "session",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuthV2AssociateSoftwareTokenResponse.attributeTypeMap;
    }
    constructor() {
    }
}
